import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import HTMLFlipBook from "react-pageflip";
const BASE = process.env.PUBLIC_URL || "";

const COPY_TEXT = "A luminous sea witch weaving constellations into glowing coral strands, her hands swirling bioluminescent sigils through enchanted seawater, shimmering tendrils of starlight drifting around her cinematic lighting, deep ocean ambience, magical atmosphere, lens 50mm f/4,";

// Set to "on" or "off" to control initial background music state
const MUSIC_START = "off";


const flipSound = new Audio(`${BASE}/sounds/flip.mp3`);

const backgroundMusic = new Audio(`${BASE}/sounds/music.mp3`);
backgroundMusic.loop = true;
backgroundMusic.volume = 0.3;



/*
  PAGE_RATIO = height / width

  Common Aspect Ratios (height / width):
    - 1.414   (A Series Paper, ISO 216, e.g. A4: 297/210)         // ~√2, used for print
    - 1.618   (Golden Ratio)                                      // art, design
    - 1.333   (4:3, old TV, some tablets, US Letter: 11/8.5)      // classic monitors, paper
    - 1.500   (3:2, 35mm photo, some laptops)                     // photography, screens
    - 1.294   (US Letter: 11/8.5)                                 // common US paper
    - 1.778   (16:9, modern displays, HD video)                   // widescreen
    - 1.200   (5:6, square-ish, used here as default)             // custom/compact
    - 1.000   (1:1, square)                                       // Instagram, icons

  Example:
    // For A4 paper:
    PAGE_RATIO = 297 / 210 ≈ 1.414
    // For 16:9 screen:
    PAGE_RATIO = 9 / 16 = 0.5625 (but usually want width/height for screens)
    // For this app's default (1.2):
    PAGE_RATIO = 1.2
*/


const PAGE_RATIO = 1.2; // height-to-width ratio
const PAGE_W = 500; // px
const PAGE_H = PAGE_W * PAGE_RATIO; // px

// Toggle this to enable/disable the cover glide animation
const ENABLE_GLIDE = true;

let pageImages = [];

// Try loading from src/pages using Webpack (bundled assets)
try {
  function importAll(r) {
    return r.keys().map(r);
  }
  pageImages = importAll(require.context('./pages', false, /\.png$/));
} catch (e) {
  // Fallback: load from public/pages (static assets)
  const BASE = process.env.PUBLIC_URL;
  pageImages = Array.from({ length: 10 }, (_, i) =>
    `${BASE}/pages/p_${String(i + 1).padStart(2, '0')}.png`
  );
}

function App() {
  const bookRef = useRef(null);
  const [phase, setPhase] = useState("closed");
  const [pageIndex, setPageIndex] = useState(0);
  const [soundOn, setSoundOn] = useState(true);
  // Initialize musicOn based on MUSIC_START
  const [musicOn, setMusicOn] = useState(MUSIC_START === "on");
  const soundOnRef = useRef(soundOn);

  useEffect(() => {
    soundOnRef.current = soundOn;
  }, [soundOn]);

  useEffect(() => {
    if (MUSIC_START === "on") {
      backgroundMusic.play().then(() => setMusicOn(true)).catch((e) => {
        console.warn("Background music blocked until user interaction:", e);
      });
    }
    // If MUSIC_START is "off", do not attempt to autoplay
  }, []);

    const playFlipSound = () => {
      if (!soundOnRef.current) return;
      flipSound.currentTime = 0;
      flipSound.volume = 0.8;
      flipSound.play().catch((e) => {
        console.warn("Flip sound blocked or failed to play:", e);
      });
    };

  // Helper to get the instance safely
const getInst = () => {
  try {
    const inst = bookRef.current?.pageFlip?.();
    if (inst) {
      const currentPage = inst.getCurrentPageIndex();
      const totalPages = inst.getPageCount();
      if (currentPage === totalPages - 1) {
        console.log("here")
        
      }
    }
    return inst;
  } catch {
    return null;
  }
};

  const handleFlip = () => {
  const inst = getInst();
  if (!inst) return;

  const idx = typeof inst.getCurrentPageIndex === "function"
    ? inst.getCurrentPageIndex()
    : 0;

  const total = typeof inst.getPageCount === "function"
    ? inst.getPageCount()
    : pageImages.length;

  setPageIndex(idx);

  if (idx === 0) {
    setPhase("closed");
  } else if (idx === total - 1) {
    setPhase("end-book");   // <- last page: use your end-book state
  } else {
    setPhase("open");
  }
};

  const handleCoverClick = () => {
    const inst = getInst();
    if (!inst) return;

    if (ENABLE_GLIDE) {
      // OPTION 1: Glide to right before opening
      setPhase("glide");
      setTimeout(() => {
        if (typeof inst.flipNext === "function") {
          inst.flipNext();
        }
      }, 50);
    } else {
      // OPTION 2: Instant open (no glide)
      if (typeof inst.flipNext === "function") {
        inst.flipNext();
      }
    }
  };

  const flipPage = (direction) => {
    const inst = getInst();
    if (!inst) return;

    if (direction === "next") {
      if (phase === "closed") {
        handleCoverClick(); // mimic keyboard behavior and glide if enabled
      } else if (typeof inst.flipNext === "function") {
        inst.flipNext();
      }
    } else if (direction === "prev") {
      if (typeof inst.flipPrev === "function") {
        inst.flipPrev();
      }
    }

    // Play sound if not on cover and sound is on
    if (phase !== "closed" && phase !== "end-book") {
      playFlipSound();
    }
  };

  const flipNext = () => {
    flipPage("next");
  };

  const flipPrev = () => {
    flipPage("prev");
  };

  useEffect(() => {
    const onKey = (e) => {
      const tag = (e.target && e.target.tagName) || "";
      if (tag === "INPUT" || tag === "TEXTAREA" || e.target?.isContentEditable) return;

      if (e.key === "ArrowRight") {
        e.preventDefault();
        flipPage("next");
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        flipPage("prev");
      }

      if (
        (e.key === "ArrowRight" || e.key === "ArrowLeft") &&
        soundOnRef.current &&
        phase !== "closed" &&
        phase !== "end-book"
      ) {
        playFlipSound();
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [phase, soundOn]);

  

  return (
    <div className="viewport">
      {/* Background image layer (opacity controlled via CSS) */}
        {/* <img
         src="/pages/1.png"
         alt="background" 
         className="bg-image" 
         aria-hidden="true" 
        />  */}
      <div
        className={`book-wrap ${phase}`}
        style={{ width: PAGE_W * 2, height: PAGE_H, "--pageW": `${PAGE_W}px` }}
      >
        <HTMLFlipBook
          className="flipbook"
          ref={bookRef}
          onInit={handleFlip}
          onFlip={handleFlip}
          width={PAGE_W}
          height={PAGE_H}
          drawShadow={false}
          maxShadowOpacity={0}
          // style={{ width: "100%", height: "100%" }}
          showCover
          useMouseEvents
          showPageCorners={false}
        >
          {pageImages.map((src, i) => (
            <div
              key={i}
              className={`page ${i === 0 ? "is-first" : ""} ${i === pageImages.length - 1 ? "is-last" : ""}`}
              onClick={() => {
                const isCover = i === 0;
                const isLast = i === pageImages.length - 1;

                if (!isCover && !isLast && soundOnRef.current) {
                  playFlipSound();
                }
              }}
              style={{ position: "relative" }}
            >
              <img src={src} alt={`Page ${i + 1}`} className="page-image" />
              {i === pageImages.length - 3 && (
                <div className="copy-section">
                  <button
                    onClick={() => navigator.clipboard.writeText(COPY_TEXT)}
                    className="copy-button"
                  >
                    Copy 📋
                  </button>
                </div>
              )}
            </div>
          ))}
        </HTMLFlipBook>

        {/* Click overlay only when closed (cover) */}
        {phase === "closed" && (
          <button className="cover-hit" aria-label="Open book" onClick={() => {
            handleCoverClick();
            // no sound for cover click
          }} />
        )}
      </div>
      {/* Side navigation arrows (moved outside .book-wrap, now direct children of .viewport) */}
      <button
        className="nav-arrow nav-prev"
        aria-label="Previous page"
        onClick={() => flipPage("prev")}
        disabled={pageIndex <= 0}
      >
        ◀
      </button>
      <button
        className="nav-arrow nav-next"
        aria-label="Next page"
        onClick={() => flipPage("next")}
        disabled={pageIndex >= pageImages.length - 1}
      >
        ▶
      </button>
      <div style={{
        position: "absolute",
        bottom: "10px",
        left: "10px",
        zIndex: 10
      }}>
        <button
          className="sound-toggle"
          onClick={() => setSoundOn(!soundOn)}
        >
          {soundOn ? "🔊 Sound: ON" : "🔇 Sound: OFF"}
        </button>
        <button
          className="music-toggle"
          onClick={() => {
            if (backgroundMusic.paused) {
              backgroundMusic.play();
              setMusicOn(true);
            } else {
              backgroundMusic.pause();
              setMusicOn(false);
            }
          }}
        >
          {musicOn ? "🎶 Music: ON" : "🎵 Music: OFF"}
        </button>
      </div>
    </div>
  );
}

export default App;